import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=486653ed&scoped=true&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=486653ed&prod&lang=css&"
import style1 from "./Chart.vue?vue&type=style&index=1&id=486653ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486653ed",
  null
  
)

export default component.exports